import { logEvent } from 'firebase/analytics';
import { analytics } from '../modules/firebase';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trackEvent = ( eventName: string, eventProperties?: any ) => {
  logEvent( analytics, eventName, eventProperties );
};
